import * as React from 'react'
import { useTranslation } from 'hooks'
import { withTranslations } from 'helpers'
import Card from '../../atoms/Card'
import Hint from '../../Hint'
import * as S from './OrderSummary.styles'
import type { Type as HintType } from '../../Hint'

const OrderSummary: React.FC<Props> = ({ rows, hint }) => {
  const { t } = useTranslation()

  return (
    <Card title={t('shared.order_summary')}>
      {hint && <Hint {...hint} />}
      {/* id for testing */}
      <div data-testid="order-summary">
        {rows.map((row, index) => (
          <S.Row
            key={row.label}
            highlight={row.highlight}
            strikethrough={row.strikethrough}
            end={index === rows.length - 1}
          >
            <span>{row.label}</span>
            <S.Detail>{row.detail}</S.Detail>
          </S.Row>
        ))}
      </div>
    </Card>
  )
}

export default withTranslations(OrderSummary)

interface Row {
  label: string
  detail: string
  highlight?: boolean
  strikethrough?: boolean
}
interface Props {
  rows: Row[]
  hint?: {
    text: string
    type?: HintType
  }
}
